<template>
  <div class="wrap">
    <!-- 顶部黑块 -->
    <div class="wrapTop">
      <!-- 视频内容 -->
      <div class="videoBox" :class="{ 'videoBox-with-knowledge': dottingList.length > 0 }">
        <div class="wrapTopsCen">
          <div class="room-title">
            <div class="elp">
              {{ detail ? detail.title : '' }}
            </div>
            <div class="detail-ter flex-c">
              <div style="cursor: pointer;" v-if="courDetail" @click="terDio = true" class="ter-list">
                <div class="terbox">
                  <el-image class="ter-img" :src="courDetail ? courDetail.tImg : ''" fit="cover" />
                </div>
                <span class="ter">讲师：{{ courDetail ? courDetail.terName : '' }}</span>
              </div>
            </div>
          </div>

          <div class="wrapTopsCenCen">
            <div class="wrapTopsCenCenL">
              <!-- <div v-if="isMp4" id="J_prismPlayers" class="prism-player">
                <div id="logo">
                  <img :src="copyright.videoLogo" style="object-fit: contain">
                </div>
              </div> -->
              <jxyplayer @player="initPlayer" @timeupdate="onKnowledgeTimeUpdate" v-if="uservideoConfig"
                :url="uservideoConfig" :options="option" />
            </div>
            <!-- 知识点片段：单条保留大卡片，多条使用可横向翻页的卡片列表。 -->
            <div v-if="dottingList.length" class="videoRBI" :class="{ isBottom: dottingList.length === 1 }">
              <div v-if="dottingList.length > 1" class="arrow" @click="leftArrow">
                <i class="iconfont icon-xiangzuo" />
              </div>
              <div ref="videoRBIViewport" class="videoRBIContent">
                <div ref="videoRBIBox" class="videoRBIBox" :style="{ left: marginLeft + 'px' }">
                  <div v-for="item in dottingList" :key="item.id" class="contentItem"
                    :class="{ onceItem: dottingList.length === 1 }">
                    <div class="img_box" @click="jumpTime(item)">
                      <img class="itemImg" :src="item.coverUrl" alt="知识点视频封面">
                      <div v-show="item.id === thisdottingId"
                        :class="dottingList.length === 1 ? 'red_borders' : 'red_border'" />
                      <div class="dottingBox">
                        <div class="dottingTime">{{ item.durationLabel }}</div>
                      </div>
                    </div>
                    <div class="name_box">
                      <div :class="dottingList.length === 1 ? 'dotting_names' : 'dotting_name'">
                        {{ item.knowledgeList[0] ? item.knowledgeList[0].name : '' }}
                      </div>
                      <div class="onceBtn">
                        <div class="item_btn" @click="openOrClose(item)">
                          <img class="item_img" src="@/assets/img/Home/Vector2.png" alt="">
                          <span class="btn_name">{{ item.isOpen ? '收起知识点' : '展开知识点' }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.isOpen" class="dsj" />
                  </div>
                  <div v-if="dottingList.length === 1" class="nomore">
                    <img src="@/assets/img/kecheng/nomore.png" alt="">
                    <span>暂无更多知识点~</span>
                  </div>
                </div>
              </div>
              <div v-if="dottingList.length > 1" class="arrow" @click="rightArrow">
                <i class="iconfont icon-xiangyou" />
              </div>
            </div>
          </div>
        </div>
        <bofang-chater v-if="ifNew" :id="courseId" class="room" :class="{ 'room-with-knowledge': dottingList.length > 0 }"
          :playid="id" :class-id="classId" />
      </div>
    </div>
    <!-- <div class="boxTips">
      <div>
        <img class="marker-img" />
        <div class="marker-text"></div>
      </div>
    </div> -->
    <!-- 知识点 -->
    <transition name="fade">
      <div v-show="isOpen" class="knowledge_points-box">
        <kowledgePoints ref="kowledgePoints" type="2" />
      </div>
    </transition>
    <!-- 选项栏 -->
    <div class="content">
      <div class="tabTwo m-t-24">
        <div class="tabTwo-text" :class="NavIndex == 1 ? 'active' : ''" @click="NavIndex = 1">
          课程答疑
          <div v-if="NavIndex == 1" class="on" />
        </div>
        <div class="tabTwo-text" :class="NavIndex == 2 ? 'active' : ''" @click="NavIndex = 2">
          课程评分
          <div v-if="NavIndex == 2" class="on" />
        </div>
      </div>
      <!-- 课程答疑 -->
      <answer-view :IsPurchase="IsPurchase" v-if="NavIndex == 1" :type="2"   :status="2" :course-id="courseId"
        :chapter-id="id" :detail="detail" />
      <!-- 课程评分 -->
      <score-evaluation :IsPurchase="IsPurchase" v-if="NavIndex == 2" :belonging="2" :chapter-id="groupId" :section-id="id" :type="3"
        :type-id="classId" :type-nmae="detail.title"   />
    </div>
  <!-- 全屏阴影块弹框 -->
    <div v-if="ifWatchingOther" class="watchOtherBg">
      <div class="watchOtherContent">
        <div class="watchOtherTitle">提示</div>
        <div class="watchOtherText">{{ watchingOtherMsg }}</div>
        <div class="watchOtherBtn" @click="goHome">确定</div>
      </div>
    </div>
    <!-- <ratingPopup :show="ratingPopupShow" :type="2" :course-id="courseId" :chapter-id="detail.groupId"
      :teacher-id="teacherId" :section-id="id" @close="closeRatingPopup" /> -->
    <!-- 是否可以观看弹窗 -->
    <!-- <div v-if="showLookDetail" class="lookBg">
      <div class="ifLook">
        <div class="prompt">提示</div>
        <div class="contents">
          您当前正在<span>{{ lookDeatil ? lookDeatil.terminal : '' }}</span>观看<span>{{ lookDeatil ? lookDeatil.chapterName :
            '' }}</span>,请关闭后再行观看其他章节。
        </div>
        <div class="button" @click="closeLook">关闭</div>
      </div>
    </div> -->
    <!-- <div v-if="terDio" class="lookterDio">
      <terDioShow :lectureId="courDetail.teacherId" @isok="isok"></terDioShow>
    </div> -->
  </div>

</template>
<script>
import Vue from 'vue'
// import {
//   getClassCourseByVideoId,
//   getClassCourseById,
//   getvideoSegmentList,
//   selectSupplyToStudentStudyRate
// } from '@/api/home'
import scoreEvaluation from '@/components/Know/course/scoreEvaluation.vue'
// import ratingPopup from '@/components/ratingPopup.vue'
import answerView from '@/components/Know/course/answerView1.vue'
import bofangChater from '@/components/Know/bofangChater.vue'
import jxyplayer from '@/components/jxyPlay.vue'
// import terDioShow from '@/components/Know/terDioShow.vue'

// import {
//   Know,
//   sendVideoHistoryDataBatch,
//   courseCheckPlay,
//   judgeIsComment
// } from '@/api/know'
// const know = new Know()
import { getInfo, getDomain } from '@/api/cookies'
import kowledgePoints from '@/components/kowledgePoints.vue'
import { videoKnowledge } from './videoKnowledge.ts'
// import { newWebSocket } from '@/common/utils/newWebSocket.js'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import { LearningRateIO } from "@/utils/socketIO";
import { setUrlParams, getUrlParams, setStyleFixed, exitStyleFixed } from "@/utils/public";
let learningIO = null; // 学习率实例
export default {
  mixins: [videoKnowledge],
  components: {
    bofangChater,
    scoreEvaluation,
    answerView,
    jxyplayer,
    // ratingPopup,
    kowledgePoints,
    // terDioShow
  },
  data() {
    return {
      copyright: {}, // 机构信息
      userInfo: {},
      openType: 1,
      // 课程详情信息
      terDio: false,
      courDetail: {},
      ifNew: false,
      // 课程节详情信息
      detail: {
        courseId: ''
      },
      // 时间戳用于学习记录
      timeStamp: new Date().getTime(),
      isAdded: false, // 保证记录成对出现
      uservideoConfig: '',
      NavIndex: 1,
      tipsShow: true,
      IsPurchase: true,
      id: null, // 章节ID
      chapterName: null, // 章节名称
      groupId: null, // 章节组ID
      courseId: null, // 录播ID
      classId: null,
      player: null,
      playerTime: 0,
      isMp4: false,
      accessKeySecret: null,
      accessKeyId: null,
      /* 学习记录 */
      option: {
        width: '880px',
        height: '498px',
        url: this.uservideoConfig,
        type: 'HLS'
      },
      setIntervals: null,
      timer: null,
      classProductLine: 0,
      status: 0,
      startTime: 0,
      getExplorer: '', // 当前浏览器
      history: 0,
      socket: null,
      ratingPopupShow: false,
      teacherId: null,
      judgeCommen: null,
      watchTime: 0,
      lookDeatil: null,
      showLookDetail: false,
      typekc: null,
      timePointBatch: [],//批量存储的学习率秒点
      semesterId: null, // 学期id
      ifWatchingOther: false,
      watchingOtherMsg: '',
    }
  },

  async created() {
    this.ifNew = false
    this.userInfo = getInfo()
    this.copyright = getDomain()
    this.$forceUpdate()
    this.id = this.$route.query.id
    this.courseId = await this.$route.query.courseId
    this.classId = this.$route.query.classId 
    this.courseYear = this.$route.query.dateYear
        let res = await homeClient.getWatchStatusPC({
    })
    if (res.code == 0) {
      await this.getDetail()
    } else {
      this.watchingOtherMsg = res.msg || '您已在观看其他课程'
      this.ifWatchingOther = true
    }
 
    this.ifNew = true

  },

  methods: {
     goHome() {
      this.$router.push('/')
    },
    initPlayer(player) {
      this.initKnowledgePlayer(player);
    },
    async getDetail() {

      await homeClient.getCourseDataLiveVo(
        {
          playId: this.id,
          teachingMethod: 2
        }
      ).then(async (res) => {

        this.detail = res.data
        this.courseId = this.detail.courseId
        this.uservideoConfig = res.data.playLink
        // 知识点独立加载，慢接口不阻塞视频播放和原有学习率连接。
        this.getvideoSegmentList()
        if (this.classId) {
          const res = await homeClient.getNewestSemester({
            classTypeId: this.classId,
          });
          if (res.code == 0) {
            this.semesterId = res.data.id;
          }
          learningIO = new LearningRateIO({
            recordPars: {
              belongCourseTitleId: this.detail.belongCourseTitle, // 课程名id
              chapterId: this.detail.groupId, // 章id
              classTypeId: this.classId, // 班型id
              courseId: this.detail.courseId, // 课程id
              nodeId: this.detail.chapterId, // 节id
              pageLocationTypeCode: 3, // 1近期直播进入观看直播中 3辅导班型进入观看直播中 6学习记录进入观看直播中
              semesterId: this.semesterId, // 学期id
              teachingMethod: 2, // 1直播 2录播
            },
          });
          learningIO.connect(
            setUrlParams({
              userId: this.userInfo.userId,
              clientTypeCode: "PC",
              chapterId: this.detail.groupId,
              classId: this.classId,
              courseId: this.detail.courseId,
              courseNameId: this.detail.belongCourseTitle,
              dateYear: this.courseYear,
              nodeId: this.detail.chapterId,
              semesterId: this.semesterId,
            })
          );
           learningIO.$on("serverPingSend", () => {
          learningIO.pingSendStudyRecord({
            userId: this.userInfo.userId,
            classId: this.classId,
            dateYear: this.courseYear,
            courseId: this.detail.courseId,
            chapterId: this.detail.groupId,
            nodeId: this.detail.chapterId,
            videoTypeCode: 2,
            clientType: "PC",
            liveStartTime: "",
            semesterId: this.semesterId,
            liveStatus: 0,
            courseNameId: this.detail.belongCourseTitle,
            videoDuration:  parseInt(this.player.duration),
            multiple: this.player.playbackRate,
            duration: parseInt(this.player.duration),
            currentSeeSec: parseInt(this.player.currentTime),
          });
        })
        }
      })
      this.$forceUpdate()
    },
    isok() {
      this.terDio = false
    },
    closeLook() {
      this.showLookDetail = false
      window.close()
    },
    clear() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    // 课程概述
    nbvs(val) {
      this.NavIndex = val
    },

    // 播放
    async crePlayer(player) {
      console.log(this.IsPurchase)
      if (
        (!this.IsPurchase || !this.userInfo) &&
        (!this.detail.audition || this.detail.audition === '0')
      ) {
        this.$message.error('未购买不能观看！')
        return
      }
    },
    closeRatingPopup() {
      this.ratingPopupShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;

  // 顶部黑块
  .wrapTop {
    width: 100%;
    overflow: hidden;
    background: #222222;
    border-radius: 0px 0px 0px 0px;

    // 上方课程名
    .wrapTopsTop {
      width: 100%;
      height: 58px;
      line-height: 58px;
      background: #383838;
      border-radius: 8px 8px 0px 0px;
      opacity: 1;
      padding: 18px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      // 左侧标题
      .wrapTopsTopL {
        width: auto;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        // 图片

        // 文字标题
        p {
          width: auto;
          height: auto;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #aaaaaa;

          span {
            color: #ffffff;
          }
        }
      }

      // 右侧返回课程介绍
      .wrapTopsTopR {
        width: auto;
        height: auto;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;

        // 文字
        span {
          width: auto;
          height: auto;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        // 返回图片
        img {
          width: 13px;
          height: 11px;
          margin-right: 5px;
        }
      }
    }

    .videoBox {
      min-height: 556px;
      max-height: 720px;
      margin: 32px auto;
      display: flex;
      // align-items: center;
      justify-content: center;

      // 知识点卡片增加播放区高度，课程目录同步拉伸，避免原高度裁掉底部内容。
      &.videoBox-with-knowledge {
        max-height: none;
        align-items: stretch;

        .room-with-knowledge {
          height: auto !important;
          max-height: 740px;
        }
      }

      // 视频内容
      .wrapTopsCen {
        width: 880px;
        margin-right: 20px;
        position: relative;

        // 视频上方提示
        .wrapTopsCenTop {
          width: 100%;
          height: 40px;
          background: #ffffff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          top: 58px;
          z-index: 99;

          // 左侧提示
          .wrapTopsCenTopL {
            width: auto;
            height: 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 16px;
              height: 16px;
              margin: 0px 10px 0px 10px;
            }

            span {
              width: auto;
              height: auto;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #f15817;
            }
          }

          // 右侧关闭
          .wrapTopsCenTopR {
            width: auto;
            height: 12px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            cursor: pointer;

            span {
              width: auto;
              height: auto;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #a8abbe;
            }

            img {
              width: 11px;
              height: 11px;
              margin: 0px 10px 0px 5px;
            }
          }
        }

        // 中间视频
        .wrapTopsCenCen {
          width: 100%;
          // height: 495px;
          margin-top: 1px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          /* align-items: center; */
          // 左视频
          .wrapTopsCenCenL {
            width: 100%;
            height: 495px;
            background: #f2f2f2;
            margin-bottom: 20px;

            .prism-player {
              width: 100%;
              height: 100%;
              position: relative;
            }

            ::v-deep {
              video {
                width: 100%;
                height: 100%;
                border-radius: 8px;
              }
            }
          }

          .isBottom {
            width: 100%;
            height: 156px !important;
            padding-top: 15px;
            padding-left: 19px;
            background-color: #fff;
            background: #1f1e24;
            border-radius: 8px;

            .videoRBIContent {
              margin: 0 !important;
            }
          }

          /* 左视频打点 */
          .videoRBI {
            height: 146px;
            width: 100%;
            display: flex;

            .arrow {
              width: 16px;
              height: 146px;
              background-color: rgba(0, 0, 0, 0.5);
              border-radius: 4px;
              text-align: center;
              line-height: 146px;
              color: #ffffff;
              cursor: pointer;
            }

            .videoRBIContent {
              width: 832px;
              flex: 1;
              min-width: 0;
              height: 169px;
              margin: 0 8px;
              overflow: hidden;
              position: relative;

              .videoRBIBox {
                display: flex;
                position: absolute;
                left: 0;
                top: 0;
                transition: left 0.2s;

                .nomore {
                  display: flex;
                  align-items: center;
                  width: 360px;
                  height: 122px;
                  background: #333333;
                  border-radius: 8px !important;
                  margin-left: 8px;
                  padding-top: 13px;
                  padding-left: 37px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #c9c9c9;
                  line-height: 27px;
                  z-index: 999;
                  overflow: hidden;

                  img {
                    width: 110px;
                    height: 110px;
                    margin-right: 16px;
                  }
                }

                .onceItem {
                  display: flex;
                  width: 456px !important;
                  height: 122px !important;
                  background: #ffffff;
                  border-radius: 8px;
                  padding-top: 4px;
                  padding-left: 6px;

                  .img_box {
                    position: relative;
                    width: 197px !important;
                    height: 111px !important;
                    margin-right: 15px;

                    img {
                      width: 100% !important;
                      height: 100% !important;
                    }

                    .dottingBox {
                      position: absolute;
                      bottom: 0;
                      background: transparent !important;
                    }
                  }

                  .name_box {
                    width: 231px !important;
                    padding: 0 !important;

                    .dotting_names {
                      width: 231px !important;
                      height: 54px;
                      font-size: 16px !important;
                      font-family: MicrosoftYaHei;
                      color: #333333;
                      line-height: 27px;
                      text-overflow: -o-ellipsis-lastline;
                      overflow: hidden; //溢出内容隐藏
                      text-overflow: ellipsis; //文本溢出部分用省略号表示
                      display: -webkit-box; //特别显示模式
                      -webkit-line-clamp: 2; //行数
                      line-clamp: 2;
                      -webkit-box-orient: vertical;
                      margin-bottom: 18px;
                    }

                    .onceBtn {
                      width: 100%;
                    }

                    .item_btn {
                      justify-content: center;
                    }
                  }
                }

                .contentItem {
                  flex-shrink: 0;
                  width: 160px;
                  height: 146px;
                  margin-right: 8px;
                  position: relative;

                  .img_box {
                    width: 160px;
                    height: 90px;
                    position: relative;

                    .itemImg {
                      width: 160px;
                      height: 90px;
                      border-radius: 8px;
                      cursor: pointer;
                    }

                    .nowPlaying {
                      width: 64px;
                      height: 24px;
                      border-radius: 8px 0 8px 0;
                      background-color: #ff5e51;
                      text-align: center;
                      line-height: 24px;
                      font-size: 12px;
                      color: #ffffff;
                      position: absolute;
                      top: 0;
                      left: 0;
                      cursor: pointer;
                    }

                    .red_borders {
                      border: 2px solid #ff5e51;
                      border-radius: 8px 8px 8px 8px;
                      width: 197px;
                      height: 111px;
                      position: absolute;
                      top: 0;
                      left: 0;
                    }

                    .red_border {
                      border: 2px solid #ff5e51;
                      border-radius: 8px 8px 0 0;
                      width: 160px;
                      height: 90px;
                      position: absolute;
                      top: 0;
                      left: 0;
                    }

                    .dottingBox {
                      width: 160px;
                      height: 24px;
                      border-radius: 0 0 8px 8px;
                      background: linear-gradient(180deg,
                          rgba(0, 0, 0, 0) 0%,
                          rgba(0, 0, 0, 0.6) 100%);
                      color: #ffffff;
                      line-height: 24px;
                      font-size: 12px;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      display: flex;
                      justify-content: space-between;
                      padding: 0 8px;
                      cursor: pointer;
                    }
                  }

                  .name_box {
                    background-color: #ffffff;
                    width: 160px;
                    height: 56px;
                    border-radius: 0 0 8px 8px;
                    padding: 10px 0 0 12px;

                    .dotting_name {
                      color: #373a42;
                      font-size: 12px;
                      width: 132px;
                      margin-bottom: 3px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }

                    .item_btn {
                      display: flex;
                      align-items: center;
                      cursor: pointer;

                      .item_img {
                        margin-right: 4px;
                        width: 13px;
                        height: 11px;
                      }

                      .btn_name {
                        color: #ff5e51;
                        font-size: 12px;
                        font-weight: 500;
                      }
                    }
                  }
                }
              }
            }
          }

          // 右头像/聊天
          .wrapTopsCenCenR {
            width: 25%;
            height: 100%;

            // 讲师头像
            .wrapTopsCenCenRT {
              width: 100%;
              height: 190px;
              background: #ffffff;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;

              img {
                width: 135px;
                height: 113px;
                margin-top: 26px;
              }

              span {
                width: auto;
                height: auto;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6a6a6a;
              }
            }

            // 聊天框
            .wrapTopsCenCenRC {
              width: 100%;
              height: 346px;

              // 聊天框顶部
              .wrapTopsCenCenRCa {
                width: 100%;
                height: 40px;
                background: #464646;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #efefef;
              }

              // 聊天框内容
              .wrapTopsCenCenRCb {
                width: 100%;
                height: 260px;
                overflow: auto;

                // overflow-y:scroll;
                // overflow-x:hidden
                // 内容盒子
                .wrapTopsCenCenRCbs {
                  width: 85%;
                  height: 32px;
                  margin: 20px auto;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;

                  // 左侧头像
                  .wrapTopsCenCenRCbsL {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    margin-right: 10px;

                    img {
                      width: 100%;
                      height: 100%;
                      border-radius: 50%;
                    }
                  }

                  // 右侧昵称/留言
                  .wrapTopsCenCenRCbsR {
                    width: auto;
                    height: 32px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;

                    span {
                      width: auto;
                      height: auto;
                      font-size: 12px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #b0b0b0;
                    }

                    p {
                      width: auto;
                      height: auto;
                      font-size: 12px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #ffffff;
                    }
                  }
                }
              }

              // 聊天框底部
              .wrapTopsCenCenRCc {
                width: 100%;
                height: 46px;
                background: #5d5d5d;
                display: flex;
                justify-content: center;
                align-items: center;

                // 内容盒子
                .wrapTopsCenCenRCcs {
                  width: 85%;
                  height: 30px;
                  background: #7a7a7a;
                  border-radius: 15px;
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;

                  // 输入框
                  input {
                    width: 70%;
                    height: 100%;
                    border: none;
                    outline: none;
                    background: #7a7a7a;
                    color: #ffffff;
                  }

                  // 修改输入框预输入文字
                  input::-webkit-input-placeholder {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #efefef;
                  }

                  // 发送
                  div {
                    width: 24%;
                    height: 100%;
                    background: #a1a1a1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 0px 15px 15px 0px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #efefef;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .knowledge_points-box {
    width: 1220px;
    max-height: 580px;
    background-color: #ffffff;
    margin: 20px auto;
    padding: 12px 32px;
    overflow: auto;
  }

  // 直播课内容
  .warpCon {
    width: 100%;
    // height: 920px;
    height: auto;
    margin-bottom: 30px;
    background: #f5f6fa;
    overflow: hidden;

    // 缩宽
    .warpCons {
      width: 65%;
      height: 100%;
      margin: auto;
      overflow: hidden;
      margin-bottom: 50px;

      .warpConss {
        width: 100%;
        height: auto;

        // 单个内容
        .warpConske {
          width: 100%;
          height: 76px;
          margin-top: 30px;
          background: #ffffff;
          border: 1px solid #ffc3bb;
          border-radius: 2px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          // 左侧标题
          .warpConskeL {
            width: auto;
            height: 19px;
            margin-left: 30px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 21px;
              height: 19px;
              margin-right: 16px;
              cursor: pointer;
            }

            p {
              width: auto;
              height: auto;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #27323f;
              cursor: pointer;

              span {
                width: auto;
                height: auto;
                margin-left: 20px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7b8196;
              }
            }
          }

          // 右侧展开/收起
          .warpConskeR {
            width: auto;
            height: 15px;
            margin-right: 30px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            cursor: pointer;

            img {
              width: 9px;
              height: 7px;
              margin-left: 7px;
            }

            span {
              width: auto;
              height: auto;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #7b8196;
            }
          }
        }

        // 单个内容展开项盒子
        .warpConskexq {
          width: 100%;
          height: auto;
          background: #ffffff;
          padding: 20px;

          .warpConskexqs {
            width: 1175px;
            height: 50px;
            background: #f7f7f7;
            display: flex;
            justify-content: space-between;
            align-items: center;

            // 左侧
            .warpConskexqsL {
              width: auto;
              height: 100%;
              display: flex;
              justify-content: flex-start;
              align-items: center;

              div {
                width: 4px;
                height: 50px;
                background: #dddddd;
                margin-right: 27px;
              }

              span {
                width: auto;
                height: auto;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                cursor: pointer;
              }
            }

            // 右侧
            .warpConskexqsR {
              width: 320px;
              height: 32px;
              display: flex;
              justify-content: flex-start;
              align-items: center;

              div {
                width: 90px;
                height: 32px;
                margin-right: 10px;
                border-radius: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .apple {
      width: 1200px;
      height: 100%;
      margin: 30px auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .appleLeft {
        width: auto;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        background: #ffffff;

        .appleLefts {
          width: 100%;
          height: auto;

          /deep/ img {
            width: 100% !important;
          }
        }
      }
    }
  }

  .room {
    width: 300px;
  }
}

#logo {
  position: absolute;
  right: 30px;
  bottom: 50px;

  img {
    // width: 100%;
    height: 40px;
  }
}

/* 章节名称 */
.room-title {
  height: 58px;
  background: #383838;
  border-radius: 8px 8px 0px 0px;
  width: 100%;
  overflow: hidden;
  opacity: 1;
  font-size: 22px;
  font-family: Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}

/* 讲师 */
.detail-ter {
  flex-shrink: 0;

  .ter {
    color: #fff;
  }
}

.content {
  width: 1220px;
  background: #ffffff;
  margin: 20px auto;
}

/deep/ .wrapTopsCen {
  .boxTips {
    position: absolute;
    width: 192px;
    height: 162px;
    display: none;
    justify-content: flex-start;
    align-items: center;
    color: #ffffff;
    bottom: 55px;
    background: rgba(0, 0, 0, 0.8);
    z-index: 19999;
    border-radius: 8px;

    .marker-img {
      width: 192px;
      height: 108px;
      z-index: 19999;
      border-radius: 8px 8px 0 0;
    }

    .marker-text {
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      width: 192px;
      height: 54px;
      padding: 6px 10px;
      font-size: 14px;
      color: #ffffff;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

.dsj {
  position: absolute;
  bottom: -12px;
  border-color: #ffffff transparent transparent transparent;
  border-style: solid;
  border-width: 12px 10px 0 10px;
  height: 0;
  width: 0;
  left: calc(50% - 10px);
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}

::v-deep .prism-setting-btn {
  display: none !important;
}

::v-deep .prism-cc-btn {
  display: none !important;
}

.lookterDio {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: rgba(0, 0, 0, .5);
}

/* 全屏阴影块弹框样式 */
.watchOtherBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.watchOtherContent {
  width: 400px;
  background: #ffffff;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.watchOtherTitle {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}

.watchOtherText {
  font-size: 16px;
  color: #666666;
  margin-bottom: 30px;
  line-height: 24px;
}

.watchOtherBtn {
  width: 120px;
  height: 40px;
  background: #409EFF;
  color: #ffffff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.watchOtherBtn:hover {
  background: #66b1ff;
}
</style>
